import React, { useEffect, useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import RecentJobs from '../components/home/RecentJobs';
import Benefits from './Benefits';

const FLASH_KEY = 'rwm_flash_message';

function HomePage() {
  const [flashMessage, setFlashMessage] = useState('');

  useEffect(() => {
    try {
      const message = sessionStorage.getItem(FLASH_KEY);
      if (message) {
        setFlashMessage(message);
        sessionStorage.removeItem(FLASH_KEY);
      }
    } catch {
      // sessionStorage unavailable
    }
  }, []);

  return (
    <div>
      {flashMessage ? (
        <Alert
          variant="success"
          className="mb-3"
          dismissible
          onClose={() => setFlashMessage('')}
          data-testid="rwm-flash-message"
        >
          {flashMessage}
        </Alert>
      ) : null}
      <Row>
        <Col>
          <RecentJobs />
          <Benefits />
        </Col>
      </Row>
    </div>
  );
}

export default HomePage;
